import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import {
  Characters,
  ItemName,
  Locale,
  WithExclusion,
  type WithExclusionObject,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * リース会社(表示用)
   */
  laCompany: string;
  /**
   * リース会社名称
   */
  laCompanyName: string;
  /**
   * リース会社コード
   */
  laCompanyCode: string;
  /**
   * リース会社マスタコード
   */
  laCompanyMstCode: string;
  /**
   * リース会社範囲(抽出条件)
   */
  laCompanyMstCodeRange: WithExclusionObject;
  /**
   * 変更後リース会社
   */
  laCompanyAfterChange: string;
  /**
   * リース会社範囲(抽出条件)
   */
  laCompanyCodeRange: WithExclusionObject;
}

const attributes = {
  laCompanyCode: Characters.preset.halfWidth({
    minLen: 25,
    maxLen: 25,
    required: true,
  }),
  laCompany: Characters.preset.halfWidth({
    minLen: 25,
    maxLen: 25,
    required: true,
  }),
  laCompanyName: Characters.preset.freeFormat(),
  laCompanyMstCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
  laCompanyCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
} satisfies ItemAttributes<Schema>;

interface Record {
  laCompany: string;
  laCompanyName: string;
  laCompanyCode: string;
  laCompanyMstCode: string;
  laCompanyMstCodeRange: string;
  isLaCompanyMstCodeRangeExcluded: boolean;
  laCompanyAfterChange: string;
  laCompanyCodeRange: string;
  isLaCompanyCodeRangeExcluded: boolean;
}

const names = {
  laCompanyCode: ItemName.of([Locale.ja, 'リース会社コード']),
  laCompany: ItemName.of([Locale.ja, 'リース会社'], [Locale.en, 'La Company']),
  laCompanyName: ItemName.of([Locale.ja, 'リース会社名称'], [Locale.en, 'La Company Name']),
  laCompanyMstCode: ItemName.of([Locale.ja, 'リース会社']),
  laCompanyMstCodeRange: ItemName.of([Locale.ja, 'リース会社範囲'], [Locale.en, 'La Company Mst Code Range']),
  laCompanyAfterChange: ItemName.of([Locale.ja, '変更後リース会社']),
  laCompanyCodeRange: ItemName.of([Locale.ja, 'リース会社範囲'], [Locale.en, 'La Company Mst Code Range']),
} satisfies ItemNames<Schema>;

const leaseCompanyMst = {
  names,
  attributes,
};

interface LeaseCompanyMst {
  schema: Schema;
  record: Record;
}

export type { LeaseCompanyMst };
export { leaseCompanyMst };
